import { useState } from "react";

import { useToast } from "@/ds";
import { alterarSituacaoCotacaoReferencia } from "@/modules/financeiro-configuracoes";
import { JUSTIFICATIVA_OBRIGATORIA } from "@/shared/components";
import { useChaveIdempotencia } from "@/shared/hooks";
import { useAtivasDaMoeda } from "../hooks/use-ativas-da-moeda";
import { formatCadastradaData, formatCompetencia, formatCotacao } from "../moedas.utils";
import {
  INATIVADA_COM_SUCESSO,
  INATIVAR_CONFIRMAR,
  INATIVAR_EFEITOS_TITULO,
  INATIVAR_INTRO,
  INATIVAR_SUBTITULO,
  INATIVAR_TITULO,
  SITUACAO_INATIVA,
  efeitosInativar,
} from "./situacao-cotacao-dialog.constants";
import type {
  SituacaoCotacaoDialogProps,
  SituacaoCotacaoDialogViewModel,
} from "./types-situacao-cotacao-dialog";

export function useSituacaoCotacaoDialog({
  cotacao,
  onClose,
  onConcluido,
}: SituacaoCotacaoDialogProps): SituacaoCotacaoDialogViewModel {
  const toast = useToast();
  const { comChave } = useChaveIdempotencia();
  const [justificativa, setJustificativa] = useState("");
  const [erroJustificativa, setErroJustificativa] = useState<string | null>(null);

  const { unicaAtiva } = useAtivasDaMoeda({ moedaId: cotacao.moeda.id, enabled: true });
  const competencia = formatCompetencia(cotacao.competencia);
  const data = formatCadastradaData(cotacao.cadastradaEm);
  const autor =
    cotacao.cadastradaPor === "Carga inicial" ? "(Carga inicial)" : `por ${cotacao.cadastradaPor}`;

  return {
    acao: "inativar",
    titulo: INATIVAR_TITULO,
    subtitulo: INATIVAR_SUBTITULO,
    confirmLabel: INATIVAR_CONFIRMAR,
    tituloEfeitos: INATIVAR_EFEITOS_TITULO,
    oQueAcontece: efeitosInativar(cotacao.moeda.codigo, unicaAtiva),
    identificacao: {
      intro: INATIVAR_INTRO,
      titulo: `${cotacao.moeda.codigo} · ${competencia}`,
      moeda: cotacao.moeda.nome,
      detalhe: `R$ ${formatCotacao(cotacao.cotacao)} · Cadastrada em ${data} ${autor}`,
    },
    justificativa: {
      valor: justificativa,
      erro: erroJustificativa,
      digitar: (texto) => {
        setJustificativa(texto);
        setErroJustificativa(null);
      },
    },
    onConfirmar: async () => {
      const texto = justificativa.trim();
      if (texto === "") {
        setErroJustificativa(JUSTIFICATIVA_OBRIGATORIA);
        return;
      }
      await comChave(
        { id: cotacao.id, situacao: SITUACAO_INATIVA, justificativa: texto },
        (idempotencyKey) =>
          alterarSituacaoCotacaoReferencia(cotacao.id, SITUACAO_INATIVA, texto, { idempotencyKey }),
      );
      toast.success(INATIVADA_COM_SUCESSO);
      onConcluido();
    },
    onCancelar: onClose,
  };
}
